import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import {
    NavBar,
    NavLeft,
    NavList,
    NavRight,
    NavMobile,
    ToggleButton,
    HeaderContainer,
} from './styles';

function Header() {
    const [toggleMenu, setToggleMenu] = useState(false);

    return (
        <>
            <HeaderContainer>
                <NavBar>
                    <NavLeft>
                        <NavList>
                            <li>
                                <Link to="/">Home</Link>
                            </li>
                            <li>
                                <a href="https://mercadomail.com.br">
                                    Mercado Mail
                                </a>
                            </li>
                            <li>
                                <a href="/declaracao-conteudo.html">
                                    Decl. de Conteúdo
                                </a>
                            </li>
                        </NavList>
                    </NavLeft>
                    <NavRight>
                        <NavList>
                            <li>
                                <a href="/calculadora.html">Calculadora</a>
                            </li>
                            <li>
                                <a href="/etiqueta-correios.html">
                                    Criar Etiqueta
                                </a>
                            </li>
                            <li>
                                <a href="/atrasos.html">Atrasos</a>
                            </li>
                            <li>
                                <a href="/contato.html">Contato</a>
                            </li>
                        </NavList>
                    </NavRight>
                </NavBar>
            </HeaderContainer>
            <ToggleButton
                type="button"
                onClick={() => setToggleMenu(!toggleMenu)}
            >
                <div />
                <div />
                <div />
            </ToggleButton>
            <NavMobile className={toggleMenu && 'active'}>
                <ul>
                    <li>
                        <Link to="/">Home</Link>
                    </li>
                    <li>
                        <a href="https://mercadomail.com.br">Mercado Mail</a>
                    </li>
                    <li>
                        <a href="/declaracao-conteudo">Decl. de Conteúdo</a>
                    </li>
                    <li>
                        <a href="/calculadora">Calculadora</a>
                    </li>
                    <li>
                        <a href="/etiqueta-correios">Criar Etiqueta</a>
                    </li>
                    <li>
                        <a href="/atrasos">Atrasos</a>
                    </li>
                    <li>
                        <a href="/contato">Contato</a>
                    </li>
                </ul>
            </NavMobile>
        </>
    );
}

export default Header;
